module.exports = __webpack_public_path__ + "static/media/ico_delete.e79181a6.svg";